module.exports = __webpack_public_path__ + "static/media/michelle_serious.b19311bd.png";